import {ChangeDetectorRef, Component, EventEmitter, Input, Output, TemplateRef, ViewChild} from '@angular/core';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {catchError, EMPTY, filter, from, map, Observable, Subscription, switchMap, tap,} from 'rxjs';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {MatTableDataSource} from '@angular/material/table';
import {PaginationModel} from '../../../../models/file-table.model';
import {MemberModel} from '../../../../models/user.model';
import {MemberService} from '../../../../services/member.service';
import {ContractsService} from '../../../../services/api/contracts.service';
import {ContractModel, ContractWrapperModel, IContractPaginationResponse} from '../../../../models/contract.model';
import {ActivatedRoute, Router} from '@angular/router';
import {AlertService} from '../../../../services/notify/alert.service';
import * as XLSX from 'xlsx'
import {NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import {TranslateService} from '@ngx-translate/core';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {AppContentDialogComponentMT} from '../../../../components/material/content-dialog/app-content-dialog.component';
import {
    columnsToDisplayBasic,
    columnsToDisplayInterDomain,
    columnsToSelectTarget,
    Contract_Table_Default_Settings,
    contractStatuses,
    CUSTOM_PROPS_TO_SHOW,
    FIELDS_TO_MERGE
} from './contract-table-const';
import {CUSTOM_PROPERTIES_PREFIX, PropertyModel} from '../../../../models/property.model';
import {UserTasksSettings} from '../../../../models/task.model';
import {DocViewComponent} from '../../../../components/doc-view/doc-view.component';
import {ProfileCardModalComponent} from '../../../../components/modal/profile-card-modal/profile-card-modal.component';
import {Title} from '@angular/platform-browser';
import {TokenService} from '../../../../services/token.service';
import {DialogsMTService} from '../../../../services/modal/dialogs-mt.service';
import {UIsettingsService} from '../../../../services/ui-settings.service';
import {IUI_SettingsTable, TUISettingsCodes} from '../../../../models/index.db..model';
import {AppUISettingsCTFormComponent} from './ui-settings/ui-settings-ct-form.component';
import {ContractDataService} from '../../../../modules/contracts/services/contract-data.service';
import {AppContractFormComponent} from "../../../../modules/contracts/controller/contract-form/contract-form.component";

type UserTasksSettingsLocal = Pick<UserTasksSettings, 'model' | 'alias'> & { index?: number }
interface ICurrentRouteParams  {
    filter:string,
    status :string
}
@Component({
    selector: 'app-contract-table-mt',
    templateUrl: './contract-table-mt.html',
    styleUrls: ['./contract-table-mt.scss'],
})
export class AppMTContractTable {
    private table_code:TUISettingsCodes = 'contractTableInstance'
    public dataSource: MatTableDataSource<ContractModel> = new MatTableDataSource();
    private dataSetFilters:ICurrentRouteParams = {filter:'all',status:''}
    public noContractsInDB:boolean = false
    private tableUISettings:IUI_SettingsTable = Contract_Table_Default_Settings as IUI_SettingsTable
    public pagination: PaginationModel = new PaginationModel();
    @ViewChild('uiPaginator') matPaginator!: MatPaginator;
    @ViewChild('intlPaginator') intlPaginator!: MatPaginator;
    public uiPaginatorOff:boolean = false
    @ViewChild(MatSort) sort!: MatSort;
    @Input() widgetView: boolean = false
    @Input() selectTargetMode: boolean = false;
    @Input() selectTargetModeGuid: string = '';
    @Output() eventSubmitSelectedTask:EventEmitter <ContractModel> = new EventEmitter<ContractModel>()
    public selectedContract:ContractModel|null = null;
    public contractStatusesArr = contractStatuses
    public textFilterInput = new FormControl('');
    public dataRange = new FormGroup({
        dateRangeStart: new FormControl<Date | null>(null),
        dateRangeEnd: new FormControl<Date | null>(null),
    });
    public customFieldsAreSet: boolean = false
    public panelOpenState = false;
    public searchForm: FormGroup;
    public currentMember!: MemberModel;
    public description = '';
    public columnsToDisplay: string[] = [];

    private customPropModels = new Map<string, PropertyModel & { index: number }>
    private customColumns!: UserTasksSettingsLocal[]

    private subscriptions = new Subscription();

    private contentDialogRef:MatDialogRef<any>|null= null
    private UISettingsDialogRef:MatDialogRef<AppUISettingsCTFormComponent>|null= null
    constructor(
        private contractApi: ContractsService,
        private contractDataService: ContractDataService,
        private memberService: MemberService,
        private fb: FormBuilder,
        private router: Router,
        private alertService: AlertService,
        public translateService: TranslateService,
        private dialog: MatDialog,
        private cdr: ChangeDetectorRef,
        private titleServce: Title,
        private tokenService: TokenService,
        private dialogsMTService: DialogsMTService,
        private route: ActivatedRoute,
        private uiSettingsService:UIsettingsService
    ) {
        this.searchForm = this.fb.group({
            dateRange: {value: null, disabled: true},
            amountRange: {value: null, disabled: true},
            contractStatuses: {value: contractStatuses, disabled: false}
        })

    }

    ngOnInit(): void {
        this.resetPaginationData()
        this.route.params.subscribe(params => {
            this.dataSetFilters = {...(params as ICurrentRouteParams)};
            if (this.dataSetFilters.status === 'all_statuses') {
                this.fgContractStatuses?.patchValue(contractStatuses)
                this.dataSetFilters.status = ''
            }
            this.columnsToDisplay = this.dataSetFilters.filter === 'my'? columnsToDisplayInterDomain : columnsToDisplayBasic
            this.selectTargetMode?  this.columnsToDisplay = columnsToSelectTarget  : null;
            this.dataSetFilters.filter === 'my'? this.fgContractStatuses?.disable() : this.fgContractStatuses?.enable()
            this.dataSetFilters.status? this.fgContractStatuses?.patchValue(this.dataSetFilters?.status?.split(',')) : null;
            this.setSubscriptions()
            this.selectTargetMode? this.getSubcontracts() :  this.submitQuery(false)
        });
    }
    ngAfterViewInit(): void {
        setTimeout(() => {
            this.titleServce.setTitle(this.translateService.instant('PAGES_TITLES.CONTRACT_TABLE'))
        }, 500);
    }
    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
        this.titleServce.setTitle(this.translateService.instant('PAGES_TITLES.DEFALUT'))
    }

    setSubscriptions() {
        this.subscriptions.add(this.fgContractStatuses?.valueChanges.subscribe(
            (states: string[]) => this.searchFormBusinessStatesChanged(states))
        );
        this.subscriptions.add(this.textFilterInput.valueChanges.subscribe
            (fil => fil ? this.dataSource.filter = fil : this.matPaginator.pageIndex=0)
        );
        this.subscriptions.add(this.contractApi.subFirstPageContractData.subscribe(firstPage => this.handleFirstPageArrived(firstPage)));
        this.subscriptions.add(this.contractDataService.subContractDeleted.asObservable().subscribe(data => this.deleteContractFromDataset(data.guid)));
        this.subscriptions.add(this.contractDataService.subContractCreated.asObservable().subscribe(data => this.addContractToDataset(data)));
        this.subscriptions.add(this.contractDataService.subContractEditedNameOrDesc.asObservable().subscribe(data => this.changeNameAndDescInContract(data)));
    }

    setUISettings(member:MemberModel): Observable<IUI_SettingsTable>{
        return this.uiSettingsService.getUISettings(member.guid).pipe(
            map(settings=>{
                let loadedSettings = settings?.tables?.find(el=>el.table_code = this.table_code)
                if (loadedSettings) {
                    Object.keys(loadedSettings).forEach(key=>{
                        let keyTyped=key as keyof IUI_SettingsTable
                        if ((this.tableUISettings[keyTyped]) && loadedSettings[keyTyped]) {
                            (this.tableUISettings[keyTyped] as string | number | string[])  = loadedSettings[keyTyped]  
                        } 
                    })
                }
                this.pagination.limit = this.tableUISettings.page_rows_qty||25
                this.matPaginator.pageSizeOptions = [this.tableUISettings.page_rows_qty||25]
                this.matPaginator.pageSize  = this.pagination.limit 
                return this.tableUISettings
            })
        )
    }
    handleFirstPageArrived(firstPage:IContractPaginationResponse) {
        this.uiPaginatorOff = true
        this.matPaginator.length = firstPage.total
        this.pagination.loaded_pages = 1;                
        this.pagination.count = firstPage.page_count
        this.updateDataSource(firstPage.data)
    }
    resetPaginationData() {
        this.matPaginator? this.matPaginator.length = 0 : null
        this.matPaginator? this.matPaginator.pageIndex = 0 : null
        this.pagination.sort_by = 'updated_at';
        this.pagination.sort = 'desc';
        this.pagination.current_page = 1;
        this.pagination.loaded_pages = 0
        this.pagination.status = this.fgContractStatuses?.value.toString();
    }
    updateDataSource(data: ContractModel[], showAlert: boolean = false, addData:boolean = false, pageIndex?:number) {
        data.length===0? this.noContractsInDB = true : this.noContractsInDB = false ;
        if (this.customFieldsAreSet === false && data.length > 0) {
            this.customColumns = data[0].custom_properties
                .map((el, ind) => {
                    return {...el, index: ind}
                })
                .filter(el => CUSTOM_PROPS_TO_SHOW.includes(el.property.title))
                .map(el => {
                    return {
                        model: el.property,
                        alias: el.property.title,
                        index: el.index
                    }
                })
            this.updateCustomCollunms();
        }
        data = this.flattenComplexData(data)
        data = data.map(el => {
            return {
                ...el,
                description_text: el.description ? this.clearText(el.description) : '',
            }
        })
        addData? this.dataSource.data.push(...data) : this.dataSource.data = data
        this.dataSource.sort = this.sort
        this.dataSource.paginator = this.intlPaginator
        showAlert ? this.alertService.setAlert('Загружено ' + data.length + ' записей', 'nd_color') : null
        this.matPaginator.length === this.dataSource.data.length?   this.matPaginator.pageSizeOptions = [10,25,50,100]:null
        this.cdr.detectChanges()
        setTimeout(() => {
            pageIndex? this.showDataSourcePage(pageIndex) : null;
            
        }, 0);
    }

    submitQuery(showAlert = true, clearDataSource = false) {
        this.resetPaginationData()
        clearDataSource ? this.dataSource.data = [] : null;
        this.pagination.status = this.fgContractStatuses?.value.toString()||'open,pre_verified,verified,completed,pause,renegotiated'
        this.pagination.status = this.pagination.status?.replace('all_statuses,','')
        from(this.memberService.getCurrentMember())
        .pipe(
            tap(member => this.currentMember = member),
            switchMap(member=>this.setUISettings(member)),
            switchMap(() => this.dataSetFilters.filter === 'all' ? 
                this.contractApi.getAllatOnce(this.pagination, this.currentMember.guid, this.currentMember.project_setting?.is_project_admin || false, this.tableUISettings.rows_qty_to_cache):
                this.contractApi.getAllMembersContractatOnce(this.pagination, this.currentMember.guid, this.currentMember.project_setting?.is_project_admin || false, this.tableUISettings.rows_qty_to_cache)
            ))
        .subscribe(data => {
            this.pagination.loaded_pages = Math.ceil(data.length/this.matPaginator.pageSize)
            this.updateDataSource(data, showAlert)
            this.uiPaginatorOff = false

        })
    }
    getSubcontracts() {
      this.contractApi.getAvailableSubcontracts(this.pagination,this.selectTargetModeGuid).subscribe(data=>{
        data.data = data.data.map(el => { 
            return { 
                ...el,  
                description_text: el.description ? this.clearText(el.description) : '' ,
                master_project_guid: el.master_project.guid,
            }})        
        this.dataSource.data = data.data
        this.dataSource.sort = this.sort
        this.dataSource.paginator = this.matPaginator
      })
    }
    deleteContractFromDataset(guid:string) {
        this.dataSource.data = this.dataSource.data.filter(el=>el.guid !== guid)
        this.matPaginator.length -= 1
    }
    addContractToDataset(data:ContractWrapperModel) {
        let transformedData = this.flattenComplexData([data.contract])
        transformedData = transformedData.map(el => {
            return {
                ...el,
                description_text: el.description ? this.clearText(el.description) : '',
            }
        })
        this.dataSource.data = [...transformedData, ...this.dataSource.data]
        this.matPaginator.length += 1
    }
    changeNameAndDescInContract(data:ContractModel) {
        let index = this.dataSource.data.findIndex(el=>el.guid === data.guid)
        let newData = { 
            ...this.dataSource.data[index],
            name:data.name,
            description: data.description,
            description_text: data.description ? this.clearText(data.description) : '',
        }
        this.dataSource.data[index] = newData
        this.dataSource.data = this.dataSource.data.slice()
    }
    updateCustomCollunms() {
        this.columnsToDisplay.splice(7, 0, ...this.customColumns.map((el, index) => {
            let colName = el.model ? CUSTOM_PROPERTIES_PREFIX + el.alias + '.property_value' : el.alias
            el.model ? this.customPropModels.set(colName, {...el.model, index: el.index || 0}) : null
            return colName
        }))
        this.customFieldsAreSet = true
    }
    selectContract(contractRow:ContractModel){
      if (this.selectTargetMode === false) {
        return
      }
      this.selectedContract = contractRow
    }
    submitSelectedTarget() {
      this.selectedContract? this.eventSubmitSelectedTask.next(this.selectedContract) : null
    }
    flattenComplexData(data: ContractModel[]): ContractModel[] {
        let deepColumns = this.columnsToDisplay.filter(el => el.includes('.'))
        data.forEach(row => {
                let contracts = Object.entries(row).filter(el => FIELDS_TO_MERGE[0].includes(el[0]) && el[1]).map(el => {
                    return {guid: el[1], type: el[0]}
                })
                let colName = FIELDS_TO_MERGE[1] as string
                Object.assign(row, {[colName]: contracts})

                deepColumns.forEach(columnKey => {
                    let keys: string[] = columnKey.split('.')
                    Object.assign(row, {[columnKey]: keys.reduce((prev: any, curr: any) => prev?.[curr], row)});
                    if (keys[0] + '.' === CUSTOM_PROPERTIES_PREFIX && this.customPropModels.get(columnKey)?.index) {
                        Object.assign(row, {[columnKey]: row.custom_properties[this.customPropModels.get(columnKey)!.index].property_values});
                        if (['property_file', 'property_member'].includes(this.customPropModels.get(columnKey)!.property_type) === false) {
                            if (typeof ((row as any)[columnKey]) === 'object' && (row as any)[columnKey]?.length) {
                                (row as any)[columnKey] = (row as any)[columnKey].map((el: any) => el.items_text).join(', ')
                            }
                        }
                    }
                })

            }
        )
        return data
    }
    onPageChange(event:PageEvent) {
          this.intlPaginator.pageSize = event.pageSize
          this.dataSource.paginator = this.intlPaginator
        if ( event.pageIndex * this.matPaginator.pageSize >= (this.dataSource?.data.length||1)) {
            this.uiPaginatorOff = true
            this.pagination.limit = event.pageSize
            this.pagination.loaded_pages! += 1;
            this.pagination.current_page = this.pagination?.loaded_pages||1
            this.contractApi.getAll(this.pagination, this.currentMember.guid, this.currentMember.project_setting?.is_project_admin || false).subscribe(res=>{
                this.uiPaginatorOff = false
                this.updateDataSource(res.data,false,true,event.pageIndex)
            })
        } else {
            this.showDataSourcePage(event.pageIndex)
        }
    }
    showDataSourcePage(pageIndex:number) {
        pageIndex > this.intlPaginator.pageIndex ?this.intlPaginator.nextPage() :  this.intlPaginator.previousPage()
    }
    openUISettings() {
      if (!this.currentMember.guid) {
        return
      }
      this.UISettingsDialogRef = this.dialog.open(AppUISettingsCTFormComponent,{minWidth:'750px'})
      this.UISettingsDialogRef.componentInstance.user_guid = this.currentMember.guid
    }
    openDialog(content: TemplateRef<any>,minWidth?:number,minHeight?:number) {
      this.contentDialogRef = this.dialog.open(AppContentDialogComponentMT,{
        panelClass:'file-toolbar-dialog',minHeight:minHeight,minWidth:minWidth, maxHeight:'95vh'
    })
      this.contentDialogRef.componentInstance.templateRef = content
    }
    showContractForm(data: ContractModel) {
        if (!data?.master_project?.domain || this.currentMember.project_setting.project.domain === data.master_project.domain) {
            this.contractApi.subStopgetAll.next(true) // doesn't work yet
            this.contractDataService.bSubContractTableRoute.next(['account','contracts',...this.route.snapshot.url.map(el=>el.path)])
            this.widgetView? this.showContractDialog(data.guid) :  this.router.navigate(['account', 'contracts', 'detail', data.guid])
        }
        if (data?.master_project?.domain && this.currentMember.project_setting.project.domain !== data.master_project.domain) {
            let actionHeader = this.translateService.instant('CONFIRM.HEADERS.ATTENTION')
            let actionBody = this.translateService.instant('CONFIRM.TEXT.GO_CONTRACT',{name: data.master_project.name})
            
            this.dialogsMTService.confirmDialog({actionHeader:actionHeader,actionBody:actionBody})
            .pipe(
                tap(()=>this.contractApi.subStopgetAll.next(true)), // doesn't work yet
                filter(res => res.isConfirmed),
                catchError(() => {
                    return EMPTY
                }))
            .subscribe(() => {
                let contractDomain = data.master_project.domain;
                let host = window.location.hostname.split('.')
                let dom = host[host.length-2] + '.' +host[host.length-1] 
                let schema = window.location.href.split('://')[0];
                let url = schema + '://' + contractDomain + '/account/contracts/detail/' + data.guid;
                let params = new URLSearchParams({
                    auth_token: this.tokenService.getToken(),
                    expires_in:this.tokenService.getExpireTime(),
                });
                document.location.href = url + '?' + params.toString()
            })
        }
    }
    showContractDialog(guid: string) {
        let contractDialogRef = this.dialog.open(AppContractFormComponent, {
            maxWidth: '1500px',
            minWidth: '80%',
            minHeight: '96vh',
            panelClass: 'contract-table-padding-modalbox'
        });
        contractDialogRef.componentInstance.contractGuid = guid
    }

    openFile(documentKey: string) {
        let docViewComponentDialogRef = this.dialog.open(DocViewComponent, {
            minWidth: '90vw',
            minHeight: '96vh',
            panelClass: 'contract-table-padding-modalbox'
        })
        docViewComponentDialogRef.componentInstance.fileUkey = documentKey
        docViewComponentDialogRef.componentInstance.zoomExt = '100'

    }

    openMember(memberGuid: string) {
        let userComponentDialogRef = this.dialog.open(ProfileCardModalComponent, {
            maxWidth: '1500px',
            width: '700px',
            minHeight: '40vh',
            panelClass: 'contract-table-padding-modalbox'
        })
        userComponentDialogRef.componentInstance.memberGuid = memberGuid
        userComponentDialogRef.componentInstance.modalView = false
    }

    openContentDialog(content: string) {
        let contentDialogRef = this.dialog.open(AppContentDialogComponentMT, {
          maxHeight:'90vh',
          panelClass: 'contract-table-padding-modalbox'})
        contentDialogRef.componentInstance.htmlContent = content
    }

    textFilterUpdate(textFilterInput: string) {
        this.dataSource.filter = textFilterInput
        this.textFilterInput.patchValue(textFilterInput)
    }

    textFilterClear() {
        this.dataSource.filter = ''
        this.textFilterInput.patchValue('')
    }

    searchFormStatesToggleAll(e:Event) {
        e.stopPropagation()
        this.fgContractStatuses?.patchValue(this.fgContractStatuses?.value.includes('all_statuses') ? [] : contractStatuses, {emitEvent: false})
    }

    searchFormBusinessStatesChanged(states: string[]) {
        if (states) {
            states.length === contractStatuses.length - 1 && !states.includes('all_statuses') ? this.fgContractStatuses?.value.push("all_statuses") : null;
            states.length !== contractStatuses.length && states.includes('all_statuses') ? this.fgContractStatuses?.value.shift() : null
            this.fgContractStatuses?.patchValue(this.fgContractStatuses.value, {emitEvent: false})
        }
    }

    clearText(val: string): string {
        return val.replace(/<[^>]*>/g, '');
    }

    tableDropColumn(event: CdkDragDrop<string[]>) {
        moveItemInArray(this.columnsToDisplay, event.previousIndex, event.currentIndex);
    }

    exportToExcel() {
        let dataTypes = {
            updated_at: 'Date',
            status_at: 'Date',
        }
        let dataToExport = structuredClone(this.dataSource.data);
        dataToExport.map((el: any) => {
            Object.keys(el).forEach(key => {
                switch (true == true) {
                    case el[key] && dataTypes[key as keyof typeof dataTypes] === 'number':
                        return el[key] = Number(el[key])
                    case el[key] && dataTypes[key as keyof typeof dataTypes] === 'Date':
                        return el[key] = new Date(el[key])
                    default:
                        return el[key] = el[key]
                }
            })
            return el;
        });
        const fileName = 'контракты' + ".xlsx";
        const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dataToExport);
        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'контракты');
        XLSX.writeFile(wb, fileName);
    }
    createContracts(contractName: HTMLInputElement, modal: NgbModalRef): void {
        if (!contractName.value) {
            this.alertService.setAlert(this.translateService.instant('ALERTS.CREATE_CONTRACT'), 'blue');
        } else {
            const data = {
                name: contractName.value,
                description: this.description ? this.description : '',
                members: []
            };
            this.contractApi.create(data)
            .pipe(tap(res=>this.contractDataService.subContractCreated.next(res.contract)))
            .subscribe({
                next: async (res: { contract: ContractWrapperModel, message: string }) => {
                    this.contentDialogRef?.close();
                    this.alertService.setAlert(res.message, 'nd_color');
                    this.router.navigate(['account', 'contracts', 'detail', res.contract.contract.guid]);
                    //this.dataSource.data.unshift(res.contract.contract);
                    this.description = '';
                }, error: error => {
                    this.alertService.setAlert(error.message, 'blue');
                }
            });
        }
    }

    get gRange() {
        return this.searchForm.get('dataRange')
    }

    get dateRangeStart() {
        return this.searchForm.get('dateRangeStart')
    }

    get dateRangeEnd() {
        return this.searchForm.get('dateRangeEnd')
    }

    get fgContractStatuses() {
        return this.searchForm.get('contractStatuses')
    }

    get amountRange() {
        return this.searchForm.get('amountRange')
    }

}